import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function LeaderPreview() {
  const navigate = useNavigate();
  const { login, user } = useAuth();
  const [params] = useSearchParams();
  const requested = useRef(false);
  const denied = useRef(false);

  useEffect(() => {
    if (requested.current) return;
    requested.current = true;
    const token = params.get("key") || "";
    (async () => {
      try {
        const { data } = await api.post("/auth/leader-bypass", { token });
        login(data.token, data.user);
      } catch (err) {
        denied.current = true;
        toast.error(err.response?.data?.detail || "Leader bypass unavailable");
      }
    })();
  }, [login, params]);

  useEffect(() => {
    if (user?.email === "leader@wingman.test" && user?.role === "leader") {
      navigate("/leader", { replace: true });
    }
  }, [user, navigate]);

  if (denied.current) {
    return <DeniedPanel />;
  }

  return (
    <div className="min-h-screen bg-[#060B14] flex items-center justify-center" data-testid="leader-preview-loading">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto mb-5 border-2 border-[#60A5FA] border-t-transparent rounded-full animate-spin" />
        <div className="hud-label text-[#60A5FA]">Initializing Leader Preview...</div>
      </div>
    </div>
  );
}

function DeniedPanel() {
  return (
    <div className="min-h-screen bg-[#060B14] flex items-center justify-center px-6" data-testid="bypass-denied">
      <div className="glass-strong rounded-sm p-10 max-w-md text-center">
        <div className="hud-label text-[#F43F5E] mb-3">Access Denied</div>
        <h2 className="font-display text-2xl text-white font-light mb-3">
          Bypass <span className="text-gold italic">key required</span>
        </h2>
        <p className="text-sm text-slate-400 mb-6">
          This preview route is gated. Append{" "}
          <code className="font-mono-aviation text-gold">?key=YOUR_TOKEN</code> to the URL.
        </p>
        <Link to="/" className="btn-ghost-gold inline-flex px-5 py-2.5 rounded-sm text-sm">
          Return Home
        </Link>
      </div>
    </div>
  );
}
